// 案件列表頁面翻譯（新版本卡片樣式）
export default {
  // 頁面標題和版本切換
  pageTitle: "研判分析-案件分析",
  switchToOldVersion: "切到舊版本",
  switchToNewVersion: "切到新版本",

  // 頂部操作區
  header: {
    updateTime: "更新時間",
    selectPlaceholder: "請選擇",
    searchPlaceholder: "請輸入{label}",
    createCase: "新建案件",
  },

  // 搜索類型選項
  searchTypes: {
    name: "案件名稱",
    caseType: "案件類型",
    createUserName: "創建人",
  },

  // 卡片內容
  card: {
    edit: "編輯",
    delete: "刪除",
    canvasCount: "[畫布數量]",
    surveyUser: "[調證用戶]",
    surveySuggests: "[調證建議]",
    updateTime: "更新時間",
    viewDetail: "查看詳情",
  },

  // 底部分頁
  footer: {
    total: "共計",
    totalUnit: "條記錄",
  },

  // 確認對話框
  confirmDialog: {
    deleteTitle: "刪除確認",
    deleteMessage: "此操作將永久刪除{caseName}案件, 是否確定?",
    confirmButton: "確定",
    cancelButton: "取消",
  },

  // 消息提示
  messages: {
    deleteSuccess: "刪除成功",
    deleteCancelled: "已取消刪除",
  },
};
